import BaseApi from './base.api';
import ApiService from '@services/api.service';

export default {
    ...BaseApi,
    ... {
        resource: 'organizations'
    },
    getTransactions(params) {
        return ApiService.get(`organization-transactions/${params.organization}`, params);
    },
    getOrganization(params) {
        return ApiService.get(`getOrganization/${params.id}`);
    },
    exportExcel(params) {
        return ApiService.get(`export/${this.resource}`, params)

    },

    getStudentTypes(params) {
        return ApiService.get(`${this.resource}/student-types`, params)
    },

    deleteTransaction(id) {
        return ApiService.delete(`organization-transactions/${id}`);
    },
}